import { IImage, ILink } from "@/src/types";
import { Wysiwyg } from "@/styles/typography";
import React, { useEffect, useState } from "react";
import S from "./RepeaterImageWithText.style";

import { getImage, GatsbyImage } from "gatsby-plugin-image";

export interface Props {
  title: string;
  backgroundColor: string;
  imageTextBlocks: {
    image: IImage;
    link: ILink;
    text: string;
  }[];
}

const RepeaterImageWithText: React.FC<Props> = (data) => {
  const { title, backgroundColor, imageTextBlocks } = data;

  const [selectedBackgroundColor, setSelectedBackgroundColor] =
    useState("white");

  useEffect(() => {
    if (backgroundColor === "white") {
      setSelectedBackgroundColor("white");
    } else if (backgroundColor === "blue") {
      setSelectedBackgroundColor("#224C5D");
    } else if (backgroundColor === "black") {
      setSelectedBackgroundColor("#000000");
    } else if (backgroundColor === "green") {
      setSelectedBackgroundColor("#2F5A50");
    }
  }, [backgroundColor]);

  const setFontColor = () => {
    if (backgroundColor === "white") {
      return "#224C5D";
    } else {
      return "#f9f9f9";
    }
  };

  const [center, setCenter] = useState(false);
  useEffect(() => {
    if (imageTextBlocks.length === 2) {
      setCenter(true);
    } else {
      setCenter(false);
    }
  }, [imageTextBlocks]);

  return (
    <div className="main-inner">
      <S.Container backgroundColor={selectedBackgroundColor}>
        <S.TitleWrapper>
          <S.Title backgroundColor={selectedBackgroundColor}>
            {title && title}
          </S.Title>
          <S.Line backgroundColor={selectedBackgroundColor}></S.Line>
        </S.TitleWrapper>
        <S.GridContainer center={center}>
          {imageTextBlocks.map((item, key: number) => {
            const imageData = item.image?.gatsbyImage
              ? getImage(item.image.gatsbyImage)
              : null;
            return (
              <S.GridItem key={key}>
                <S.ImageWrapper
                  href={item.link?.url}
                  target={item.link?.target}
                >
                  {imageData && (
                    <GatsbyImage
                      className="gatsby-image"
                      image={imageData}
                      alt={item.image.altText}
                    />
                  )}
                </S.ImageWrapper>
                <S.TextWrapper>
                  <Wysiwyg
                    color={setFontColor()}
                    dangerouslySetInnerHTML={{
                      __html: item.text && item.text,
                    }}
                  />
                </S.TextWrapper>
              </S.GridItem>
            );
          })}
        </S.GridContainer>
      </S.Container>
    </div>
  );
};

export default RepeaterImageWithText;
